import ensureError from "@-/com.npmjs.ensure-error";

/**
 * The actor (study) database could not be opened, so nothing that reads or writes study data can
 * work until it is recovered. Every actor query and mutation rejects with this while the open is
 * latched as failed; the original failure is the `cause` and keeps its message.
 *
 * Typed so the UI can tell "your study data is unavailable — contact support" apart from an
 * ordinary failed request, while everything that does not need study data keeps working.
 */
export class ActorDatabaseUnavailableError extends Error {
  constructor(cause: unknown) {
    super(ensureError(cause).message, { cause });
    this.name = "ActorDatabaseUnavailableError";
  }
}
